import CommunicationsListItem from '../communications/CommunicationsListItem';
import CoursesListItem from '../courses/CoursesListItem';
import GroupsListItem from '../groups/GroupsListItem';
import LeaveListItem from '../leave/LeaveListItem';
import RequestsListItem from '../requests/RequestsListItem';
import SkillsListItem from '../skills/SkillsListItem';
import UsersListItem from '../users/UsersListItem';

const listItems = {
	communications: CommunicationsListItem,
	courses: CoursesListItem,
	groups: GroupsListItem,
	leave: LeaveListItem,
	requests: RequestsListItem,
	skills: SkillsListItem,
	users: UsersListItem
};

export default listItems;
